import styled from 'styled-components';

export const MatchViewWrapper = styled.div`
  background-color: ${props => props.theme.colors.mainColor};
  border: 1px solid ${props => props.theme.colors.gray};
  //height: 242px;
`;

export const MatchViewTeam = styled.div`
  display: flex;
  justify-content: ${props => (props.toLeft ? 'flex-start' : 'flex-end')};
`;

export const MatchResult = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  overflow: visible;
`;

/*export const Gradient = styled.span`
  width: 100%;
  position: absolute;
  background: linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(253,233,235,0.59) 38%,rgba(253,233,235,1) 64%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#fde9eb',GradientType=0 );
  bottom: -14px;
  height: 50px;
`;*/

export const PreMatchWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;



// WEBPACK FOOTER //
// ./src/components/MatchViewGazzanet/styles.js